import React from 'react';

/** Components */
import Traffic from './MiniWidgets/Traffic';
import Weather from './MiniWidgets/Weather';

/** Constants */
const miniWidgetComponents = (type, userId) => {
  switch (type) {
    case 'traffic':
      return <Traffic key={Math.random()} userId={userId} />;
    case 'weather':
      return <Weather key={Math.random()} />;
    default:
      return null;
  }
};

const miniWidgetList = [
  {
    type: 'traffic',
    name: 'Tráfico'
  },
  {
    type: 'weather',
    name: 'Tiempo'
  }
];

const MiniWidgetList = ({ ...userId }) => {
  if (userId) {
    return miniWidgetList.map(miniWidget =>
      miniWidgetComponents(miniWidget.type, userId)
    );
  }
  return [];
};

export default MiniWidgetList;
